/**
 * Returns true if browser is from PDF Service.
 */
export function isPrintToPdfMode() {
    return navigator.userAgent === 'juvare-pdf-service';
}
